function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var Template = require('./saito-transaction-monitor.template');
var _require = require('saito-js/lib/transaction'),
  TransactionType = _require.TransactionType;
var SaitoTransactionMonitor = /*#__PURE__*/function () {
  function SaitoTransactionMonitor(app, mod) {
    var _this = this,
      _app$connection;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SaitoTransactionMonitor);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay.clickBackdropToClose = false;
    this.tx = null;
    this.nft_id = '';
    this.callback = null;
    this.options = {};
    this._countdown_timer = null;
    // Set when confirmation is detected; delivered when the completion UI is dismissed.
    this._completion_result = null;

    // Invalidates in-flight recent-block lookups after cancel / re-render / complete.
    this._watch_generation = 0;
    this._reconcile_in_flight = 0;
    this._recent_block_lookback = 6;
    this._reconcile_every_ticks = 3;

    //
    // wrap onConfirmation
    //
    if (mod && typeof mod.onConfirmation === 'function') {
      var existing = mod.onConfirmation.bind(mod);
      mod.onConfirmation = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.onConfirmation.apply(_this, _args);
              _context.n = 1;
              return existing.apply(void 0, _args);
            case 1:
              return _context.a(2, _context.v);
          }
        }, _callee);
      }));
    }

    //
    // Native SAITO payments are confirmed via WASM slip events, not only
    // module onConfirmation. Match the watched signature when present.
    //
    if (app !== null && app !== void 0 && (_app$connection = app.connection) !== null && _app$connection !== void 0 && _app$connection.on) {
      app.connection.on('on-payment-sent', function (payload) {
        _this.onPaymentSent(payload);
      });
    }
  }

  /**
   * Begin watching a transaction and show the waiting UI.
   *
   * options:
   *   tx                 - transaction to monitor
   *   nft_id             - bound NFT to watch for. A matching bound transaction
   *                        addressed to this browser closes the monitor.
   *   callback           - fired when the monitor finishes:
   *                        { status: 'confirmed' } after the user dismisses
   *                        the completion dialog, or { status: 'cancelled' }
   *                        if they close while still waiting
   *   title / lead / subtitle
   *   successTitle / successLead / successActionLabel
   *   auto_continue_on_confirm - if true, skip the completion dialog and fire
   *                        the confirmed callback as soon as the tx confirms
   */
  return _createClass(SaitoTransactionMonitor, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._watch_generation += 1;
      this.stopCountdown();
      this.options = options;
      this.tx = options.tx || null;
      this.nft_id = String(options.nft_id || '').trim();
      this.callback = typeof options.callback === 'function' ? options.callback : null;
      this._completion_result = null;
      this.overlay.clickBackdropToClose = false;
      this.overlay.show(Template.pending({
        title: options.title || 'Waiting for Confirmation',
        lead: options.lead || 'Your transaction has been broadcast to the Saito network.',
        subtitle: options.subtitle !== undefined ? options.subtitle : 'It will become visible once included in a block.'
      }), function () {
        _this2.onOverlayClosed();
      });
      this.startCountdown();

      // Safety net: the conf=0 callback is one-shot and may already have fired.
      var generation = this._watch_generation;
      void this.reconcileIfAlreadyConfirmed(generation);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var btn = document.querySelector('.saito-transaction-monitor [data-action="continue"]');
      if (!btn) {
        return;
      }
      btn.onclick = function (e) {
        e.preventDefault();
        _this3.hide();
      };
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(blk, tx, conf) {
      if (Number(conf) !== 0) {
        return;
      }
      this.completeWith(blk, tx);
    }

    /**
     * A bound transaction addressed to this browser whose third slip is the
     * watched NFT. Slip 2 is the recipient. Slip 3 is the NFT id.
     */
  }, {
    key: "matchesWatchedNft",
    value: function matchesWatchedNft(tx) {
      var _this$app, _this$app2, _this$app2$computeNFT;
      var wanted = String(this.nft_id || '').trim();
      if (!wanted || !tx) {
        return false;
      }
      if (Number(tx.type) !== Number(TransactionType.Bound)) {
        return false;
      }
      var me = String(((_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.wallet) === null || _this$app === void 0 ? void 0 : _this$app.publicKey) || '').trim();
      if (!me || typeof tx.isTo !== 'function' || tx.isTo(me) !== true) {
        return false;
      }
      var nftId = (_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.wallet) === null || _this$app2 === void 0 || (_this$app2$computeNFT = _this$app2.computeNFTIdFromTx) === null || _this$app2$computeNFT === void 0 ? void 0 : _this$app2$computeNFT.call(_this$app2, tx);
      return String(nftId || '') === wanted;
    }

    /**
     * Native SAITO: wallet maps WASM on-transaction-sent → on-payment-sent
     * with a `signature` field. Complete when it matches the watched tx.
     */
  }, {
    key: "onPaymentSent",
    value: function onPaymentSent() {
      var _this$tx;
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!((_this$tx = this.tx) !== null && _this$tx !== void 0 && _this$tx.signature)) {
        return;
      }
      var signature = payload === null || payload === void 0 ? void 0 : payload.signature;
      if (!signature || signature !== this.tx.signature) {
        return;
      }
      this.completeWith({
        id: payload.block_id != null ? payload.block_id : null,
        hash: payload.block_hash || null
      }, {
        signature: signature
      });
    }

    /**
     * Shared completion for the live confirmation callback and the recent-block
     * reconciliation check. No-ops if this watch is no longer pending.
     */
  }, {
    key: "completeWith",
    value: function completeWith(blk, tx) {
      var _this$tx2,
        _this4 = this;
      if (this._completion_result) {
        return;
      }
      var nftMatch = this.matchesWatchedNft(tx);
      var signatureMatch = !!((_this$tx2 = this.tx) !== null && _this$tx2 !== void 0 && _this$tx2.signature && (tx === null || tx === void 0 ? void 0 : tx.signature) === this.tx.signature);
      if (!nftMatch && !signatureMatch) {
        return;
      }
      this._watch_generation += 1;
      this.stopCountdown();
      var txOrdinal = null;
      var blockTxs = Array.isArray(blk === null || blk === void 0 ? void 0 : blk.transactions) ? blk.transactions : [];
      if (tx !== null && tx !== void 0 && tx.signature && blockTxs.length) {
        var idx = blockTxs.findIndex(function (candidate) {
          return (candidate === null || candidate === void 0 ? void 0 : candidate.signature) === tx.signature;
        });
        if (idx >= 0) {
          txOrdinal = idx;
        }
      }
      this._completion_result = {
        status: 'confirmed',
        tx: tx,
        signature: tx.signature,
        blockId: (blk === null || blk === void 0 ? void 0 : blk.id) != null ? String(blk.id) : null,
        txOrdinal: txOrdinal != null ? String(txOrdinal) : null,
        blk: blk
      };
      this.tx = null;
      if (nftMatch) {
        this.nft_id = '';
      }

      // NFT arrival closes the monitor. The wallet already holds the NFT.
      if (nftMatch || this.options.auto_continue_on_confirm) {
        var result = this._completion_result;
        this._completion_result = null;
        this.fireCallback(result);
        this.overlay.close();
        return;
      }
      this.overlay.clickBackdropToClose = true;
      this.overlay.show(Template.complete({
        title: this.options.successTitle || 'Confirmed',
        lead: this.options.successLead || '',
        actionLabel: this.options.successActionLabel || 'Continue'
      }), function () {
        _this4.onOverlayClosed();
      });
      this.attachEvents();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.stopCountdown();
      this.overlay.close();
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      this._watch_generation += 1;
      this.stopCountdown();
      if (this._completion_result) {
        // User dismissed the completion dialog (Continue / close / backdrop).
        var result = this._completion_result;
        this._completion_result = null;
        this.fireCallback(result);
      } else if (typeof this.callback === 'function') {
        // User closed while still waiting for confirmation.
        this.fireCallback({
          status: 'cancelled'
        });
      }
      this.tx = null;
      this.nft_id = '';
      this.callback = null;
      this.options = {};
      this._completion_result = null;
      this.overlay.clickBackdropToClose = false;
    }
  }, {
    key: "fireCallback",
    value: function fireCallback(result) {
      if (typeof this.callback !== 'function') {
        return;
      }
      var cb = this.callback;
      this.callback = null;
      cb(result);
    }

    /**
     * If the watched transaction is already in a recent longest-chain block,
     * complete through the same path as onConfirmation. Ignores results after
     * cancel, re-render, or a competing completion.
     */
  }, {
    key: "reconcileIfAlreadyConfirmed",
    value: function () {
      var _reconcileIfAlreadyConfirmed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(generation) {
        var _this$tx3;
        var _this$tx4, _this$tx5, found, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(generation !== this._watch_generation)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!(!((_this$tx3 = this.tx) !== null && _this$tx3 !== void 0 && _this$tx3.signature) && !String(this.nft_id || '').trim())) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (!(this._reconcile_in_flight === generation)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              this._reconcile_in_flight = generation;
              _context2.p = 4;
              _context2.n = 5;
              return this.findWatchedTransactionInRecentBlocks();
            case 5:
              found = _context2.v;
              if (!(generation !== this._watch_generation)) {
                _context2.n = 6;
                break;
              }
              return _context2.a(2);
            case 6:
              if (found) {
                _context2.n = 7;
                break;
              }
              return _context2.a(2);
            case 7:
              if (!((_this$tx4 = this.tx) !== null && _this$tx4 !== void 0 && _this$tx4.signature && found.tx.signature !== this.tx.signature)) {
                _context2.n = 8;
                break;
              }
              return _context2.a(2);
            case 8:
              if (!(!((_this$tx5 = this.tx) !== null && _this$tx5 !== void 0 && _this$tx5.signature) && !this.matchesWatchedNft(found.tx))) {
                _context2.n = 9;
                break;
              }
              return _context2.a(2);
            case 9:
              this.completeWith(found.blk, found.tx);
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t = _context2.v;
            case 11:
              _context2.p = 11;
              if (this._reconcile_in_flight === generation) {
                this._reconcile_in_flight = 0;
              }
              return _context2.f(11);
            case 12:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 10, 11, 12]]);
      }));
      function reconcileIfAlreadyConfirmed(_x) {
        return _reconcileIfAlreadyConfirmed.apply(this, arguments);
      }
      return reconcileIfAlreadyConfirmed;
    }()
    /**
     * Look for the watched signature in the most recent longest-chain blocks.
     * Presence there is the same fact conf=0 reports. SPV / empty-signature
     * bodies are skipped so they cannot false-complete the monitor.
     */
  }, {
    key: "findWatchedTransactionInRecentBlocks",
    value: function () {
      var _findWatchedTransactionInRecentBlocks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$tx6,
          _this$app3,
          _this5 = this;
        var signature, nftId, blockchain, latestId, startId, id, hash, block, txs, looksSpv, found, _t2, _t3, _t4, _t5, _t6;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              signature = ((_this$tx6 = this.tx) === null || _this$tx6 === void 0 ? void 0 : _this$tx6.signature) || '';
              nftId = String(this.nft_id || '').trim();
              if (!(!signature && !nftId)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, null);
            case 1:
              blockchain = (_this$app3 = this.app) === null || _this$app3 === void 0 ? void 0 : _this$app3.blockchain;
              if (!(!blockchain || typeof blockchain.getLatestBlockId !== 'function')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, null);
            case 2:
              latestId = 0;
              _context3.p = 3;
              _t2 = Number;
              _context3.n = 4;
              return blockchain.getLatestBlockId();
            case 4:
              latestId = _t2(_context3.v);
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              return _context3.a(2, null);
            case 6:
              if (!(!Number.isFinite(latestId) || latestId <= 0)) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2, null);
            case 7:
              startId = Math.max(1, latestId - this._recent_block_lookback + 1);
              id = latestId;
            case 8:
              if (!(id >= startId)) {
                _context3.n = 30;
                break;
              }
              if (!signature) {
                _context3.n = 10;
                break;
              }
              if (!(!this.tx || this.tx.signature !== signature)) {
                _context3.n = 9;
                break;
              }
              return _context3.a(2, null);
            case 9:
              _context3.n = 11;
              break;
            case 10:
              if (!(String(this.nft_id || '').trim() !== nftId)) {
                _context3.n = 11;
                break;
              }
              return _context3.a(2, null);
            case 11:
              hash = '';
              _context3.p = 12;
              if (!(typeof blockchain.getLongestChainHashAtId === 'function')) {
                _context3.n = 14;
                break;
              }
              _context3.n = 13;
              return blockchain.getLongestChainHashAtId(id);
            case 13:
              hash = _context3.v;
            case 14:
              _context3.n = 16;
              break;
            case 15:
              _context3.p = 15;
              _t4 = _context3.v;
              return _context3.a(3, 29);
            case 16:
              if (hash) {
                _context3.n = 17;
                break;
              }
              return _context3.a(3, 29);
            case 17:
              block = null;
              if (!(typeof blockchain.loadBlockAsync === 'function')) {
                _context3.n = 21;
                break;
              }
              _context3.p = 18;
              _context3.n = 19;
              return blockchain.loadBlockAsync(String(hash));
            case 19:
              block = _context3.v;
              _context3.n = 21;
              break;
            case 20:
              _context3.p = 20;
              _t5 = _context3.v;
              block = null;
            case 21:
              if (!(!block && typeof blockchain.getBlock === 'function')) {
                _context3.n = 25;
                break;
              }
              _context3.p = 22;
              _context3.n = 23;
              return blockchain.getBlock(String(hash), true);
            case 23:
              block = _context3.v;
              _context3.n = 25;
              break;
            case 24:
              _context3.p = 24;
              _t6 = _context3.v;
              block = null;
            case 25:
              if (block) {
                _context3.n = 26;
                break;
              }
              return _context3.a(3, 29);
            case 26:
              txs = Array.isArray(block.transactions) ? block.transactions : [];
              if (txs.length) {
                _context3.n = 27;
                break;
              }
              return _context3.a(3, 29);
            case 27:
              looksSpv = txs.every(function (candidate) {
                return !(candidate !== null && candidate !== void 0 && candidate.signature);
              });
              if (!looksSpv) {
                _context3.n = 28;
                break;
              }
              return _context3.a(3, 29);
            case 28:
              found = signature ? txs.find(function (candidate) {
                return (candidate === null || candidate === void 0 ? void 0 : candidate.signature) === signature;
              }) : txs.find(function (candidate) {
                return _this5.matchesWatchedNft(candidate);
              });
              if (!found) {
                _context3.n = 29;
                break;
              }
              return _context3.a(2, {
                blk: block,
                tx: found
              });
            case 29:
              id--;
              _context3.n = 8;
              break;
            case 30:
              return _context3.a(2, null);
          }
        }, _callee3, this, [[22, 24], [18, 20], [12, 15], [3, 5]]);
      }));
      function findWatchedTransactionInRecentBlocks() {
        return _findWatchedTransactionInRecentBlocks.apply(this, arguments);
      }
      return findWatchedTransactionInRecentBlocks;
    }()
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      var _this6 = this;
      this.stopCountdown();

      // Consensus timing lives in options (no blockchain getter).
      // Block production window is 2 × heartbeat (same rule as burn-fee readiness).
      var heartbeatMs = this.getHeartbeatIntervalMs();
      var blockWindowSeconds = Math.max(1, Math.round(2 * heartbeatMs / 1000));
      var generation = this._watch_generation;

      // First paint: remaining time in the current production window.
      var seconds = this.getSecondsUntilNextBlockWindow(blockWindowSeconds);
      var ticks = 0;
      var renderSeconds = function renderSeconds() {
        var el = typeof document !== 'undefined' ? document.querySelector('.saito-transaction-monitor .countdown') : null;
        if (el) {
          el.textContent = String(seconds);
        }
      };
      renderSeconds();
      this._countdown_timer = setInterval(function () {
        seconds -= 1;
        if (seconds <= 0) {
          // Missed this window — always restart a full 2×heartbeat cycle.
          // Do not reuse the initial partial "time until next block" remaining.
          seconds = blockWindowSeconds;
        }
        renderSeconds();
        ticks += 1;
        if ((_this6.tx || _this6.nft_id) && ticks % _this6._reconcile_every_ticks === 0) {
          void _this6.reconcileIfAlreadyConfirmed(generation);
        }
      }, 1000);
    }

    /**
     * Heartbeat interval in milliseconds from consensus options.
     */
  }, {
    key: "getHeartbeatIntervalMs",
    value: function getHeartbeatIntervalMs() {
      var _this$app4;
      var raw = Number((_this$app4 = this.app) === null || _this$app4 === void 0 || (_this$app4 = _this$app4.options) === null || _this$app4 === void 0 || (_this$app4 = _this$app4.consensus) === null || _this$app4 === void 0 ? void 0 : _this$app4.heartbeat_interval);
      if (!Number.isFinite(raw) || raw <= 0) {
        return 30000;
      }
      // Values below 1000 are almost certainly seconds, not milliseconds.
      if (raw < 1000) {
        return Math.round(raw * 1000);
      }
      return Math.round(raw);
    }

    /**
     * Seconds remaining until the end of the current 2×heartbeat production window
     * measured from the last block timestamp.
     */
  }, {
    key: "getSecondsUntilNextBlockWindow",
    value: function getSecondsUntilNextBlockWindow(blockWindowSeconds) {
      var _this$app5;
      var lastTs = Number(((_this$app5 = this.app) === null || _this$app5 === void 0 || (_this$app5 = _this$app5.options) === null || _this$app5 === void 0 || (_this$app5 = _this$app5.blockchain) === null || _this$app5 === void 0 ? void 0 : _this$app5.last_timestamp) || 0);
      if (!Number.isFinite(lastTs) || lastTs <= 0) {
        return blockWindowSeconds;
      }
      var elapsedSec = Math.max(0, Math.floor((Date.now() - lastTs) / 1000));
      var intoWindow = elapsedSec % blockWindowSeconds;
      if (elapsedSec > 0 && intoWindow === 0) {
        // Exactly on a window boundary — start a fresh full cycle.
        return blockWindowSeconds;
      }
      var remaining = blockWindowSeconds - intoWindow;
      return remaining > 0 ? remaining : blockWindowSeconds;
    }
  }, {
    key: "stopCountdown",
    value: function stopCountdown() {
      if (this._countdown_timer) {
        clearInterval(this._countdown_timer);
        this._countdown_timer = null;
      }
    }
  }]);
}();
module.exports = SaitoTransactionMonitor;